import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Box } from "../../box/src";
import { Skeleton } from "../../skeleton/src";
export const UserPresentationLoading = (_a) => {
    var props = __rest(_a, []);
    return (_jsxs(Box, Object.assign({ "data-testid": "loading-user-presentation", width: "100%" }, props, { children: [_jsx(AvatarSkeleton, { height: 60, mr: 4, width: 60 }), _jsx(Box, { alignItems: "flex-start", flex: 1, flexDirection: "row", justifyContent: "space-between", width: "100%", children: _jsxs(Box, { flexDirection: "column", height: "100%", justifyContent: "center", width: "100%", children: [_jsx(Skeleton, { width: "30%" }), _jsx(Skeleton, { mt: 2, width: "50%" })] }) })] })));
};
const AvatarSkeleton = styled(Skeleton) `
  border-radius: 50%;
`;
//# sourceMappingURL=UserPresentationLoading.js.map